import StepResumeComponentView from './stepResumeComponentView.html';
import './stepResumeComponent.scss';
class StepResumeComponentController {
    $onInit() {
        this.valuesList = JSON.parse(this.value);
    }
    $onChanges(onChangesObj) {
        this.valuesList = JSON.parse(this.value);
    }
    async redirectToStep() {
        const $data = parseInt(this.step);
        this.redirect({ $data });
    }
}
export const StepResume = {
    template: StepResumeComponentView,
    controller: StepResumeComponentController,
    controllerAs: '$ctrl',
    bindings: {
        title: '@?',
        value: '@?',
        step: '@?',
        groupName: '@?',
        redirect: '&?',
        disableButton: '<',
    },
};
